/**
 * "From Other Conversations": threads homed elsewhere (a personal Ask Casey
 * thread, another client's Requests) that worked on this case or client.
 * Each opens at its own home. Empty for the practice and on any error.
 */
import { useEffect, useState } from "react";

import { AgentAPI, type AgentThread } from "../api/agentApi";
import { panelThreadPath } from "../routes";
import type { AgentScope } from "../types";

export const elsewherePath = (thread: AgentThread): string =>
  panelThreadPath({ kind: thread.scope_kind, id: thread.scope_id }, thread.id);

export const useElsewhereThreads = (
  scope: Pick<AgentScope, "kind" | "id"> | null,
  refreshKey?: unknown
): AgentThread[] => {
  const [threads, setThreads] = useState<AgentThread[]>([]);
  const kind = scope?.kind ?? null;
  const id = scope?.id ?? null;
  useEffect(() => {
    setThreads([]);
    if (!id || (kind !== "case" && kind !== "client")) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const list = await AgentAPI.listElsewhere({ kind, id });
        if (!cancelled) setThreads(Array.isArray(list) ? list : []);
      } catch {
        // Findability only; the home's own threads still list.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [kind, id, refreshKey]);
  return threads;
};
